class PricingRule {
    constructor(json) {
        if (json) {
            this.id = json.id;
            this.type = json.type;
            this.materials = json.materials || []; // Array of materials
            this.standardClass = json.standardClass;
            this.discount = json.discount;
        } else {
            this.id = 0;
            this.type = 'VPF';
            this.materials = [];
            this.standardClass = 0;
            this.discount = 0;
        }
    }
}

export default PricingRule;
